import type { FetchOptions, APIResponse, QueryParams } from '@/types/api.types';
import type { CommandAcceptedJson } from '@/types/polling.types';
import { apiClient } from '@/api/client';

// Each helper returns union to allow CQRS bodies
export async function get<T>(
  endpoint: string,
  params?: QueryParams,
  options?: FetchOptions
): Promise<APIResponse<T> | CommandAcceptedJson> {
  return await apiClient<T>(endpoint, { ...options, method: 'GET' }, params);
}

export async function post<T>(
  endpoint: string,
  body?: unknown,
  options?: FetchOptions
): Promise<APIResponse<T> | CommandAcceptedJson> {
  return await apiClient<T>(endpoint, {
    ...options,
    method: 'POST',
    body: body !== undefined ? JSON.stringify(body) : undefined,
    headers: { ...options?.headers, 'Content-Type': 'application/json' },
  });
}

export async function put<T>(
  endpoint: string,
  body?: unknown,
  options?: FetchOptions
): Promise<APIResponse<T> | CommandAcceptedJson> {
  return await apiClient<T>(endpoint, {
    ...options,
    method: 'PUT',
    body: body !== undefined ? JSON.stringify(body) : undefined,
    headers: { ...options?.headers, 'Content-Type': 'application/json' },
  });
}

export async function patch<T>(
  endpoint: string,
  body?: unknown,
  options?: FetchOptions
): Promise<APIResponse<T> | CommandAcceptedJson> {
  return await apiClient<T>(endpoint, {
    ...options,
    method: 'PATCH',
    body: body !== undefined ? JSON.stringify(body) : undefined,
    headers: { ...options?.headers, 'Content-Type': 'application/json' },
  });
}

export async function del<T>(
  endpoint: string,
  options?: FetchOptions
): Promise<APIResponse<T> | CommandAcceptedJson> {
  return await apiClient<T>(endpoint, { ...options, method: 'DELETE' });
}
